function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5992 17.3065C14.2321 17.3065 17.1984 14.3396 17.1984 10.6532C17.1984 6.96693 14.2321 4 10.5992 4C6.96636 4 4 6.96693 4 10.6532C4 14.3396 6.96636 17.3065 10.5992 17.3065ZM10.5992 19.3065C15.3484 19.3065 19.1984 15.4323 19.1984 10.6532C19.1984 5.87419 15.3484 2 10.5992 2C5.85 2 2 5.87419 2 10.6532C2 15.4323 5.85 19.3065 10.5992 19.3065Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M20.6746 21.9553C20.3406 21.9445 20.0229 21.807 19.7854 21.5705L17.7489 19.1902C17.3123 18.7909 17.2766 18.1123 17.6689 17.6689C17.8525 17.4831 18.1021 17.3787 18.3625 17.3787C18.6229 17.3787 18.8725 17.4831 19.0562 17.6689L21.6172 19.7181C21.9862 20.0957 22.1 20.6563 21.9079 21.1492C21.7158 21.6422 21.2536 21.9754 20.728 22L20.6746 21.9553Z",
  fill: "white"
});
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2a158ef2.svg";
export { ForwardRef as ReactComponent };